var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41864 8.48872C1.11449 6.51172 0.810337 4.53477 0.506187 2.55777C0.438737 2.11952 0.937387 1.82062 1.29209 2.08667C2.23969 2.79737 3.18724 3.50802 4.13484 4.21872C4.44684 4.45272 4.89134 4.37657 5.10764 4.05207L7.47429 0.502066C7.72439 0.126916 8.27559 0.126916 8.52569 0.502066L10.8923 4.05207C11.1086 4.37657 11.5531 4.45267 11.8651 4.21872C12.8127 3.50802 13.7603 2.79737 14.7079 2.08667C15.0626 1.82062 15.5612 2.11952 15.4938 2.55777C15.1897 4.53477 14.8855 6.51172 14.5814 8.48872H1.41864Z",
    fill: "#FCD200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8949 11.7792H2.10471C1.72571 11.7792 1.41846 11.4719 1.41846 11.0929V9.58545H14.5812V11.0929C14.5812 11.4719 14.2739 11.7792 13.8949 11.7792Z",
    fill: "#FCD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.f9077a27285924eddecf665936d5e06e.svg";
export { ForwardRef as ReactComponent };